export const ICONS_BY_CATEGORY = {
  islamic: [
    // Islamic Donations & Charity
    "mdi:islam",
    "mdi:mosque",
    "mdi:mosque-outline",
    "mdi:moon-waning-crescent",
    "mdi:star-and-crescent",
    "mdi:book-quran",
    "fa-solid:mosque",
    "fa-solid:kaaba",
    "fa-solid:star-and-crescent",
    "fa-solid:book-quran",
    "fa-solid:hands-praying",
    "fa-solid:person-praying",
    "bx:bxs-mosque",
    "bx:bx-mosque",
    "tabler:mosque",
    "tabler:quran",
    "tabler:crescent",
    "ri:mosque-line",
    "carbon:prayer",

    // Zakat (الزكاة)
    "mdi:hand-coin",
    "mdi:hand-coin-outline",
    "mdi:purse",
    "mdi:purse-outline",
    "mdi:scales",
    "mdi:scale-balance",
    "fa-solid:scale-balanced",
    "fa-solid:hand-holding-dollar",
    "bx:bx-money-withdraw",
    "tabler:scale",
    "tabler:coins",
    "ri:scales-3-line",
    "carbon:percentage",

    // Sadaqah (الصدقة)
    "mdi:heart-plus",
    "mdi:heart-plus-outline",
    "mdi:gift-open",
    "fa-solid:hands-holding",
    "bx:bx-gift",
    "tabler:gift",
    "tabler:heart-plus",
    "ri:heart-add-line",
    "carbon:gift",

    // Udhiya/Qurbani (الأضحية)
    "mdi:sheep",
    "mdi:cow",
    "mdi:camel",
    "mdi:food-drumstick",
    "fa-solid:sheep",
    "fa-solid:cow",
    "fa-solid:camel",
    "fa-solid:drumstick-bite",
    "bx:bx-meat",
    "tabler:meat",
    "ri:restaurant-2-line",
    "carbon:agriculture",

    // Fidyah (الفدية)
    "mdi:food-apple",
    // "mdi:food",
    "mdi:basket",
    "mdi:basket-outline",
    "fa-solid:apple-alt",
    "fa-solid:basket-shopping",
    "bx:bx-food-basket",
    "tabler:bread",
    "tabler:basket",
    "ri:basket-line",
    "carbon:fruit-bowl",

    // Kaffarah (الكفارة)
    "mdi:hand-peace",
    "fa-solid:hand-peace",
    "bx:bx-handicap",
    "tabler:hand-stop",
    "ri:hand-heart-line",

    // Waqf (الوقف)
    "mdi:home-group",
    "mdi:castle",
    "fa-solid:landmark",
    "bx:bx-building-house",
    "tabler:building-hospital",
    "tabler:building-school",
    "ri:government-line",
    "carbon:building-insights",

    // Fitrah (الفطرة)
    "mdi:grain",
    "mdi:wheat",
    "fa-solid:seedling",
    "fa-solid:wheat-alt",
    "fa-solid:rice-bowl",
    "bx:bx-bowl-rice",
    "tabler:plant",
    "ri:seedling-line",
    "carbon:crop",

    // Islamic Finance
    "mdi:bank-transfer",
    "mdi:swap-horizontal",
    "fa-solid:money-bill-transfer",
    "fa-solid:handshake",
    "bx:bx-transfer",
    "ri:exchange-line",
  ],

  donation: [
    // Donation & Charity
    "mdi:hand-heart",
    "mdi:hand-heart-outline",
    "mdi:charity",
    "mdi:heart",
    "mdi:heart-outline",
    "mdi:heart-multiple",
    "mdi:gift",
    "mdi:gift-outline",
    "fa-solid:hand-holding-usd",
    "fa-regular:heart",
    "fa-solid:donate",
    "bx:bx-donate-heart",
    "bx:bx-heart",
    "tabler:heart",
    "tabler:heart-filled",
    "tabler:coin",
    "heroicons-outline:heart",
    "heroicons-solid:heart",
    "ic:outline-favorite",
    "ic:baseline-favorite",
    "bi:heart",
    "bi:heart-fill",
    "ri:heart-line",
    "ri:heart-fill",
    "carbon:favorite",
    "carbon:favorite-filled",
  ],

  organization: [
    // Organization & Building
    "mdi:office-building",
    "mdi:office-building-outline",
    "mdi:account-group",
    "mdi:account-group-outline",
    "mdi:bank",
    "mdi:bank-outline",
    "mdi:home-city",
    "mdi:domain",
    "mdi:city",
    "fa-solid:building",
    "fa-regular:building",
    "fa-solid:university",
    "fa-solid:users",
    "bx:bx-buildings",
    "bx:bx-building",
    "tabler:building",
    "tabler:building-skyscraper",
    "tabler:building-community",
    "heroicons-outline:office-building",
    "heroicons-solid:office-building",
    "ic:outline-business",
    "ic:baseline-business",
    "bi:building",
    "bi:buildings",
    "ri:building-line",
    "carbon:building",
  ],

  finance: [
    // Finance & Money
    "mdi:cash",
    "mdi:cash-multiple",
    "mdi:credit-card",
    "mdi:credit-card-outline",
    "mdi:wallet",
    "mdi:wallet-outline",
    "mdi:currency-usd",
    "mdi:currency-eur",
    "fa-solid:money-bill-wave",
    "fa-solid:money-bill",
    "fa-solid:credit-card",
    "fa-solid:wallet",
    "fa-solid:coins",
    "bx:bx-money",
    "bx:bx-credit-card",
    "tabler:currency-dollar",
    "tabler:currency-euro",
    "tabler:wallet",
    "heroicons-outline:cash",
    "heroicons-solid:cash",
    "ic:outline-attach-money",
    "ic:baseline-attach-money",
    "bi:cash",
    "bi:credit-card",
    "ri:money-dollar-circle-line",
    "carbon:money",
    "carbon:finance",
  ],

  social: [
    // Social Media
    "mdi:facebook",
    "mdi:twitter",
    "mdi:instagram",
    "mdi:linkedin",
    "mdi:youtube",
    "mdi:whatsapp",
    "mdi:telegram",
    "mdi:tiktok",
    "mdi:share-variant",
    "fa-brands:facebook",
    "fa-brands:facebook-square",
    "fa-brands:twitter",
    "fa-brands:twitter-square",
    "fa-brands:instagram",
    "fa-brands:instagram-square",
    "fa-brands:linkedin",
    "fa-brands:youtube",
    "fa-brands:whatsapp",
    "fa-brands:whatsapp-square",
    "fa-brands:telegram",
    "fa-brands:tiktok",
    "bx:bxl-facebook",
    "bx:bxl-twitter",
    "bx:bxl-instagram",
    "bx:bxl-linkedin",
    "bx:bxl-youtube",
    "bx:bxl-whatsapp",
    "tabler:brand-facebook",
    "tabler:brand-twitter",
    "tabler:brand-instagram",
    "tabler:brand-linkedin",
    "tabler:brand-youtube",
    "tabler:brand-whatsapp",
    "heroicons-outline:share",
    "ri:facebook-fill",
    "ri:twitter-fill",
    "ri:instagram-line",
    "carbon:logo-facebook",
    "carbon:logo-twitter",
    "carbon:logo-instagram",
    "carbon:logo-linkedin",
    "carbon:logo-youtube",
  ],

  contact: [
    // Contact & Communication
    "mdi:phone",
    "mdi:phone-outline",
    "mdi:email",
    "mdi:email-outline",
    "mdi:message",
    "mdi:chat",
    "mdi:forum",
    "fa-solid:phone",
    "fa-solid:phone-alt",
    "fa-solid:envelope",
    "fa-solid:envelope-open",
    "fa-solid:comment",
    "fa-solid:comments",
    "bx:bx-phone",
    "bx:bx-envelope",
    "bx:bx-message",
    "tabler:phone",
    "tabler:mail",
    "tabler:message",
    "heroicons-outline:phone",
    "heroicons-outline:mail",
    "heroicons-solid:phone",
    "heroicons-solid:mail",
    "ic:outline-phone",
    "ic:baseline-phone",
    "bi:telephone",
    "bi:envelope",
    "ri:phone-line",
    "ri:mail-line",
    "carbon:phone",
    "carbon:email",
  ],

  location: [
    // Location & Maps
    "mdi:map-marker",
    "mdi:map-marker-outline",
    "mdi:map",
    "mdi:earth",
    "mdi:navigation",
    "mdi:compass",
    "fa-solid:map-marker-alt",
    "fa-solid:globe",
    "fa-solid:location-arrow",
    "fa-solid:compass",
    "bx:bx-map",
    "bx:bx-map-alt",
    "bx:bx-current-location",
    "tabler:map-pin",
    "tabler:map",
    "tabler:world",
    "heroicons-outline:location-marker",
    "heroicons-solid:location-marker",
    "ic:outline-place",
    "ic:baseline-place",
    "bi:geo-alt",
    "bi:globe",
    "ri:map-pin-line",
    "ri:global-line",
    "carbon:location",
    "carbon:earth",
  ],

  ui: [
    // UI & Navigation
    "mdi:home",
    "mdi:home-outline",
    "mdi:information",
    "mdi:information-outline",
    "mdi:settings",
    "mdi:settings-outline",
    "mdi:menu",
    "mdi:account",
    "mdi:account-outline",
    "mdi:bell",
    "mdi:bell-outline",
    "mdi:search",
    "mdi:arrow-right",
    "mdi:arrow-left",
    "mdi:chevron-right",
    "mdi:chevron-left",
    "mdi:check",
    "mdi:close",
    "mdi:plus",
    "mdi:minus",
    "fa-solid:home",
    "fa-solid:info-circle",
    "fa-solid:cog",
    "fa-solid:user",
    "fa-solid:bell",
    "fa-solid:search",
    "bx:bx-home",
    "bx:bx-info-circle",
    "bx:bx-cog",
    "bx:bx-user",
    "tabler:home",
    "tabler:info-circle",
    "tabler:settings",
    "heroicons-outline:home",
    "heroicons-outline:cog",
    "heroicons-solid:home",
    "heroicons-solid:cog",
    "ic:outline-home",
    "ic:baseline-home",
    "bi:house",
    "bi:gear",
    "ri:home-line",
    "ri:settings-line",
    "carbon:home",
    "carbon:settings",
  ],

  documents: [
    // Documents & Info
    "mdi:file-document",
    "mdi:file-document-outline",
    "mdi:clipboard-text",
    "mdi:note-text",
    "fa-solid:file-alt",
    "fa-solid:clipboard-list",
    "bx:bx-file",
    "bx:bx-note",
    "tabler:file-text",
    "tabler:clipboard-text",
    "heroicons-outline:document-text",
    "heroicons-solid:document-text",
    "ic:outline-description",
    "ic:baseline-description",
    "bi:file-text",
    "bi:clipboard",
    "ri:file-text-line",
    "ri:clipboard-line",
    "carbon:document",
  ],

  media: [
    // Media & Images
    "mdi:image",
    "mdi:image-outline",
    "mdi:camera",
    "mdi:camera-outline",
    "mdi:video",
    "mdi:play",
    "mdi:play-circle",
    "fa-solid:image",
    "fa-solid:camera",
    "fa-solid:video",
    "fa-solid:play-circle",
    "bx:bx-image",
    "bx:bx-camera",
    "bx:bx-video",
    "tabler:photo",
    "tabler:camera",
    "tabler:video",
    "heroicons-outline:photograph",
    "heroicons-solid:photograph",
    "ic:outline-image",
    "ic:baseline-image",
    "bi:image",
    "bi:camera",
    "ri:image-line",
    "ri:camera-line",
    "carbon:image",
    "carbon:camera",
  ],

  people: [
    // People & Team
    // "mdi:account-group",
    // "mdi:account-group-outline",
    "mdi:account-multiple",
    "mdi:human",
    "fa-solid:user-friends",
    // "fa-solid:users",
    "fa-solid:user-plus",
    "fa-solid:child",
    "bx:bx-group",
    "bx:bx-user-plus",
    "tabler:users",
    "tabler:user",
    "tabler:user-plus",
    "heroicons-outline:users",
    "heroicons-solid:users",
    "ic:outline-people",
    "ic:baseline-people",
    "bi:people",
    "bi:person-plus",
    "ri:user-line",
    "ri:team-line",
    "carbon:user",
    "carbon:user-multiple",
  ],

  food: [
    // Food & Help
    "mdi:food",
    "mdi:water",
    "mdi:water-outline",
    "fa-solid:utensils",
    "bx:bx-food-menu",
    "bx:bx-water",
    "tabler:food",
    "ri:restaurant-line",
    "carbon:restaurant",
  ],

  education: [
    // Education & Learning
    "mdi:school",
    "mdi:school-outline",
    "mdi:calculator",
    "fa-solid:graduation-cap",
    "fa-solid:calculator",
    "bx:bx-book",
    "bx:bx-book-open",
    "tabler:school",
    "tabler:book",
    "tabler:calculator",
    "heroicons-outline:academic-cap",
    "ic:outline-school",
    "bi:book",
    "ri:book-line",
    "carbon:education",
  ],

  transportation: [
    // Transportation & Logistics
    "mdi:car",
    "mdi:car-outline",
    "mdi:truck",
    "mdi:bus",
    "mdi:airplane",
    "fa-solid:car",
    "fa-solid:truck",
    "fa-solid:bus",
    "fa-solid:plane",
    "bx:bx-car",
    "bx:bx-truck",
    "tabler:car",
    "tabler:truck",
    "tabler:plane",
    "heroicons-outline:truck",
    "ic:outline-directions-car",
    "bi:truck",
    "ri:car-line",
    "carbon:car",
  ],

  weather: [
    // Weather & Environment
    "mdi:weather-sunny",
    "mdi:weather-rainy",
    "mdi:weather-cloudy",
    "mdi:thermometer",
    "fa-solid:sun",
    "fa-solid:cloud-rain",
    "fa-solid:snowflake",
    "fa-solid:thermometer-half",
    "bx:bx-sun",
    "bx:bx-cloud-rain",
    "tabler:sun",
    "tabler:cloud-rain",
    "tabler:temperature",
    "heroicons-outline:sun",
    "ic:outline-wb-sunny",
    "bi:sun",
    "ri:sun-line",
    "carbon:sun",
  ],

  security: [
    // Security & Protection
    "mdi:shield",
    "mdi:shield-outline",
    "mdi:shield-check",
    "mdi:lock",
    "mdi:lock-outline",
    "mdi:lock-open",
    "fa-solid:shield-alt",
    "fa-solid:lock",
    "fa-solid:unlock",
    "bx:bx-shield",
    "bx:bx-lock",
    "tabler:shield",
    "tabler:shield-check",
    "tabler:lock",
    "heroicons-outline:shield-check",
    "ic:outline-security",
    "bi:shield-lock",
    "ri:shield-line",
    "carbon:security",
  ],

  health: [
    // Health & Medical
    "mdi:medical-bag",
    "mdi:stethoscope",
    "mdi:ambulance",
    "fa-solid:heartbeat",
    "fa-solid:stethoscope",
    "fa-solid:user-md",
    "bx:bx-plus-medical",
    "bx:bx-clinic",
    "heroicons-outline:beaker",
    "ic:outline-local-hospital",
    "bi:hospital",
    "ri:health-book-line",
  ],

  prayer: [
    // Prayer & Worship
    "mdi:pray",
    "bx:bx-pray",
    "tabler:pray",
    "heroicons-outline:moon",
    "ic:outline-nights-stay",
    "bi:moon",
    "ri:moon-line",
    "carbon:night-clear",
  ],

  calendar: [
    // Calendar & Time
    "mdi:calendar",
    "mdi:calendar-outline",
    "mdi:clock",
    "mdi:clock-outline",
    "mdi:timer",
    "fa-solid:calendar",
    "fa-solid:calendar-alt",
    "fa-solid:clock",
    "fa-solid:stopwatch",
    "bx:bx-calendar",
    "bx:bx-time",
    "tabler:calendar",
    "tabler:clock",
    "tabler:hourglass",
    "heroicons-outline:calendar",
    "ic:outline-date-range",
    "bi:calendar",
    "ri:calendar-line",
    "carbon:calendar",
  ],
};
